import React, { useState } from "react";
import { PAUSE_ENCOUNTERS } from "./data.js";

export default function PauseStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [phase, setPhase] = useState("initial"); // initial | choices | resolved
  const [resolved, setResolved] = useState(null);
  const [log, setLog] = useState([]);

  const encounter = PAUSE_ENCOUNTERS[index];
  const done = index >= PAUSE_ENCOUNTERS.length;

  const reactNow = () => {
    const choice = { id: "react-now", label: "React right now", tag: "bad", result: encounter.reactNowResult };
    setLog((prev) => [...prev, { label: encounter.label, choice }]);
    setResolved(choice);
    setPhase("resolved");
  };

  const takePause = () => setPhase("choices");

  const chooseResponse = (choice) => {
    setLog((prev) => [...prev, { label: encounter.label, choice }]);
    setResolved(choice);
    setPhase("resolved");
  };

  const advance = () => {
    const isLast = index + 1 >= PAUSE_ENCOUNTERS.length;
    if (isLast) {
      onComplete({ log });
      return;
    }
    const next = PAUSE_ENCOUNTERS[index + 1];
    setResolved(null);
    setPhase(next.hasPauseStep ? "initial" : "choices");
    setIndex((i) => i + 1);
  };

  if (done) return null;

  const tagStyle = {
    good: "border-lime bg-lime/10 text-lime",
    weak: "border-gold bg-gold/10 text-gold",
    bad: "border-danger bg-danger/10 text-danger",
  };

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/50">
        <span>THE PAUSE</span>
        <span>
          {index + 1}/{PAUSE_ENCOUNTERS.length}
        </span>
      </div>

      <div className="animate-popIn mb-5 border-2 border-black bg-ink p-5">
        <p className="pixel-heading mb-3 text-sm text-mist">{encounter.label}</p>
        <p className="text-sm leading-relaxed text-mist/80">{encounter.text}</p>
      </div>

      {phase === "initial" && (
        <div className="grid grid-cols-2 gap-3">
          <button
            onClick={reactNow}
            className="border-2 border-danger px-4 py-4 font-display text-[9px] uppercase text-danger transition-colors hover:bg-danger hover:text-ink"
          >
            React Right Now
          </button>
          <button
            onClick={takePause}
            className="border-2 border-cyan px-4 py-4 font-display text-[9px] uppercase text-cyan transition-colors hover:bg-cyan hover:text-ink"
          >
            Take The Pause
          </button>
        </div>
      )}

      {phase === "choices" && !resolved && (
        <div className="space-y-2">
          {(encounter.pausedChoices || encounter.choices).map((choice) => (
            <button
              key={choice.id}
              onClick={() => chooseResponse(choice)}
              className="w-full border-2 border-mist/30 px-4 py-3 text-left text-xs text-mist transition-colors hover:border-cyan hover:text-cyan"
            >
              {choice.label}
            </button>
          ))}
        </div>
      )}

      {phase === "resolved" && resolved && (
        <div className={`animate-popIn border-2 p-4 text-center ${tagStyle[resolved.tag]}`}>
          <p className="mb-3 text-xs">{resolved.result}</p>
          <button onClick={advance} className="btn-cyan !text-[9px]">
            CONTINUE ▶
          </button>
        </div>
      )}
    </div>
  );
}
